import { createSlice } from "@reduxjs/toolkit";

export interface CourseProgress {
  progressStatus: string;
  courseId: string;
  progressPercentage: number;
  status: string;
  moduleList: Module[];
}

// Module type
export interface Module {
  moduleId: string;
  progressPercentage: number;
  status: string;
  lockedModuleId: string | null;
  lockedContentId: string | null;
  chapterList: Chapter[];
}

// Chapter type
export interface Chapter {
  contentId: string;
  contentType: string;
  progressPercentage: number;
  moduleId: string;
  status: string;
  lockedModuleId: string | null;
  lockedContentId: string | null;
  securedScore: number | null;
}

const INIT_STATE: { data: CourseProgress } = { data: {} as CourseProgress };

const CourseProgressSlice = createSlice({
  name: "CourseProgressSlice",
  initialState: INIT_STATE,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    }
  }
});

export default CourseProgressSlice;

export const CourseProgressSliceActions = CourseProgressSlice.actions;
